import { getViewport } from 'lib-utils'

const handleProductCarousel = {
  init: () => {
    document.addEventListener('DOMContentLoaded', () => {
      handleProductCarousel.main()
    })
  },

  main: () => {
    const styles = {
      disabled: {
        backgroundColor: '#D9DBDA',
        textColor: '#4b4b4b',
      },
      enabled: {
        backgroundColor: '#5812CD',
        textColor: '#ffffff',
      },
    }
    const breakpoints = 786
    const carousels = handleProductCarousel.getCarousel()

    if (carousels.length === 0) return

    handleProductCarousel.handleButtonStyles(breakpoints, styles, carousels)
    handleProductCarousel.updateSlidesPerPage(breakpoints, carousels)
    handleProductCarousel.observeInertAttributes(carousels)

    window.addEventListener('nova:resize-width', () =>
      handleProductCarousel.updateSlidesPerPage(breakpoints, carousels)
    )
  },

  getCarousel: () => {
    const mainCarousels = Array.from(
      document.querySelectorAll('.js-product-carousel')
    )

    const shadowHosts = Array.from(
      document.querySelectorAll('nova-product-recommendations')
    )

    const shadowCarousels = shadowHosts.flatMap((shadowHost) => {
      return shadowHost.shadowRoot
        ? Array.from(
          shadowHost.shadowRoot.querySelectorAll('.js-product-carousel')
        )
        : []
    })

    return [...mainCarousels, ...shadowCarousels]
  },

  updateSlidesPerPage(breakpoints, carousels) {
    if (window.innerWidth < breakpoints) return

    for (const carousel of carousels) {
      const viewport = getViewport()
      switch (viewport) {
        case 'small-mobile':
        case 'mobile':
          carousel.setAttribute('slides-per-page', 1.35)
          break
        case 'tablet':
          carousel.setAttribute('slides-per-page', 2)
          break
        case 'desktop':
          carousel.setAttribute('slides-per-page', 4.05)
          break
        case 'large-desktop':
          carousel.setAttribute('slides-per-page', 5.04)
          break
        default:
          carousel.setAttribute('slides-per-page', 4.05)
          break
      }
    }
  },

  updateButtonStyles: (button, styles, carousel) => {
    button.style.opacity = 1
    const slot = button.querySelector('slot')
    const assignedNodes = slot.assignedNodes({ flatten: true })
    const isDisabled = button.classList.contains(
      'carousel__navigation-button--disabled'
    )
    const { backgroundColor, textColor } = isDisabled
      ? styles.disabled
      : styles.enabled

    for (const node of assignedNodes) {
      node.style.backgroundColor = backgroundColor
      for (const path of node.querySelectorAll('path')) {
        path.style.stroke = textColor
      }
    }

    if (isDisabled) handleProductCarousel.meetEndOfCarousel(button, carousel)
  },

  updateDisabledButtonStyles: (button, styles, carousel) => {
    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'class'
        ) {
          handleProductCarousel.updateButtonStyles(button, styles, carousel)
        }
      }
    })
    observer.observe(button, { attributes: true })
  },

  meetEndOfCarousel: (button, carousel) => {
    let buttonDirection = null
    if (button.classList.contains('carousel__navigation-button--previous')) {
      buttonDirection = 'previous'
    } else if (button.classList.contains('carousel__navigation-button--next')) {
      buttonDirection = 'next'
    }

    if (!buttonDirection) return
    if (buttonDirection === 'previous') {
      carousel.previous()
    } else if (buttonDirection === 'next') {
      carousel.next()
    }
  },

  handleButtonStyles(breakpoints, styles, carousels) {
    if (window.innerWidth < breakpoints) return

    for (const carousel of carousels) {
      handleProductCarousel.applyStylesToButtons(carousel, styles)

      const observer = new MutationObserver(() => {
        handleProductCarousel.applyStylesToButtons(carousel, styles)
        observer.disconnect()
      })

      observer.observe(carousel.shadowRoot, { childList: true, subtree: true })
    }
  },

  applyStylesToButtons: (carousel, styles) => {
    const buttons = carousel.shadowRoot.querySelectorAll('button')
    for (const button of buttons) {
      handleProductCarousel.updateButtonStyles(button, styles, carousel)
      handleProductCarousel.updateDisabledButtonStyles(button, styles, carousel)
    }
  },

  observeInertAttributes: (carousels) => {
    for (const carousel of carousels) {
      const carouselItems = carousel.querySelectorAll('sl-carousel-item')
      for (const item of carouselItems) {
        item.removeAttribute('inert')

        const observer = new MutationObserver((mutations) => {
          for (const mutation of mutations) {
            if (
              mutation.type === 'attributes' &&
              mutation.attributeName === 'inert'
            ) {
              item.removeAttribute('inert')
            }
          }
        })
        observer.observe(item, { attributes: true })
      }
    }
  },
}
handleProductCarousel.init()

export const handleProductCarouselMain = handleProductCarousel.main
